import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingBag, X } from 'lucide-react';
interface Sale {
  name: string;
  city: string;
  minutesAgo: number;
}
const SALES: Sale[] = [{
  name: 'María',
  city: 'Córdoba',
  minutesAgo: 3
}, {
  name: 'Jorge',
  city: 'Rosario',
  minutesAgo: 6
}, {
  name: 'Lucía',
  city: 'La Plata',
  minutesAgo: 2
}, {
  name: 'Carlos',
  city: 'Mendoza',
  minutesAgo: 9
}, {
  name: 'Sofía',
  city: 'Mar del Plata',
  minutesAgo: 4
}, {
  name: 'Roberto',
  city: 'San Miguel de Tucumán',
  minutesAgo: 7
}, {
  name: 'Valeria',
  city: 'Salta',
  minutesAgo: 1
}, {
  name: 'Daniel',
  city: 'Neuquén',
  minutesAgo: 11
}, {
  name: 'Patricia',
  city: 'Santa Fe',
  minutesAgo: 5
}, {
  name: 'Gabriel',
  city: 'Bahía Blanca',
  minutesAgo: 8
}];
export function SalesPopup() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    const VISIBLE_MS = 5000; // how long each popup stays on screen
    const GAP_MS = 13000; // quiet gap between popups (≥ 10s so it doesn't disrupt reading)
    const FIRST_DELAY_MS = 8000;
    let timer: ReturnType<typeof setTimeout>;
    const show = () => {
      setVisible(true);
      timer = setTimeout(hide, VISIBLE_MS);
    };
    const hide = () => {
      setVisible(false);
      setIndex(i => (i + 1) % SALES.length);
      timer = setTimeout(show, GAP_MS);
    };
    timer = setTimeout(show, FIRST_DELAY_MS);
    return () => clearTimeout(timer);
  }, [dismissed]);
  const sale = SALES[index];
  return <AnimatePresence data-id="element-145">
      {visible && !dismissed && <motion.div initial={{
      opacity: 0,
      x: -30,
      y: 10
    }} animate={{
      opacity: 1,
      x: 0,
      y: 0
    }} exit={{
      opacity: 0,
      x: -30
    }} transition={{
      type: 'spring',
      stiffness: 200,
      damping: 24
    }} className="fixed bottom-5 left-5 z-50 max-w-[19rem] bg-white rounded-2xl shadow-xl border border-gray-100 p-4 flex items-start gap-3" role="status" aria-live="polite" data-id="element-146">
          <div className="w-10 h-10 rounded-full bg-green-100 flex items-center justify-center text-primary flex-shrink-0" data-id="element-147">
            <ShoppingBag className="w-5 h-5" data-id="element-148" />
          </div>
          <div className="pr-4" data-id="element-149">
            <p className="text-sm text-gray-900 font-semibold leading-snug" data-id="element-150">
              {sale.name} de {sale.city}
            </p>
            <p className="text-sm text-gray-500 leading-snug" data-id="element-151">
              acaba de comprar la Enciclopedia
            </p>
            <p className="text-xs text-primary font-medium mt-1" data-id="element-152">
              hace {sale.minutesAgo} min · compra verificada
            </p>
          </div>
          <button onClick={() => setDismissed(true)} aria-label="Cerrar notificación" className="absolute top-2 right-2 text-gray-300 hover:text-gray-500 transition-colors" data-id="element-153">
            <X className="w-4 h-4" data-id="element-154" />
          </button>
        </motion.div>}
    </AnimatePresence>;
}